/**
 * The connection fee: EVI's, per charger.
 *
 * Warren's rulings, recorded here because this is where the fee's
 * numbers live (the settlement rule is @evi/billing connectionFee.ts):
 *
 *   2026-09-26 launch prompt, decision 2: "The connection fee is EVI's.
 *   Set per charger by EVI, default $1, retained entirely. It no longer
 *   splits with the host. Energy splits 85/15. The v1 fees of $0.50, $1
 *   and $3 carry over as per-charger settings."
 *
 *   2026-09-23: "The connection fee applies only to sessions where
 *   energy is priced. A free charger stays free, no fee, no card
 *   required. tariffCanBill must not flip on a default fee alone."
 *
 *   2026-09-23: "THE DEAD FEE MODEL: retire it. At cutover, map each v1
 *   connection fee to the new per-charger field so the fee bills."
 *
 * SUPERSEDED: the 2026-09-16 home ruling that the plug-in fee was the
 * host's, set in the earn walk, defaulting to $1 and splitting 90/10
 * like energy (formerly in residentialFees.ts). The host no longer sets
 * a fee at all; Tariff.rates.flat_fee bills only on sessions that
 * started before the fee was pinned.
 *
 * Mechanics:
 *   - Charger.connection_fee_cents. null = no fee. Written by EVI staff
 *     only (super_admin on PUT /chargers/:id); every create path stamps
 *     DEFAULT_CONNECTION_FEE_CENTS.
 *   - Pinned onto Session.connection_fee_at_start_cents at start, gated
 *     on the BILLING tariff: a session that cannot bill anything pins 0.
 *   - Carved out of the split at settlement and kept by EVI whole
 *     (Payout.breakdown.connection_fee_cents).
 *
 * Here, in @evi/shared, not @evi/billing: the PWA and the admin app
 * render these numbers and depend on shared, never on billing.
 */
/** The fee a new charger is created with: $1.00. */
export const DEFAULT_CONNECTION_FEE_CENTS = 100;
/** The absolute ceiling on a charger's connection fee: $20.00. The
 *  schema enforces it; the "rate x 5" relative cap that bounded the
 *  host's plug-in fee does not apply to EVI's fee. */
export const CONNECTION_FEE_MAX_CENTS = 2000;
/** True for a value the schema would store: an integer in
 *  [0, CONNECTION_FEE_MAX_CENTS], or null for "no fee". */
export function isValidConnectionFeeCents(v) {
    return v === null
        || (typeof v === 'number' && Number.isInteger(v) && v >= 0 && v <= CONNECTION_FEE_MAX_CENTS);
}
//# sourceMappingURL=connectionFee.js.map